"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseResponseJson = parseResponseJson;
exports.getSettingsErrorMessage = getSettingsErrorMessage;

function parseResponseJson(response) {
  // No response. Typical of connection errors.
  if (!response) {
    return {};
  }

  try {
    return JSON.parse(response);
  } catch (parseError) {
    LOG.warn("Failed to parse response JSON from string: \"" + response + "\"");
    return {};
  }
}

function getSettingsErrorMessage(res) {
  return parseResponseJson(res.response).message || '';
}